// @ts-ignore
import { generateActions } from './utils'

const paymentDefinition = {
  fetchList: ['accountId'],
  createCard: ['accountId', 'stripePaymentId'],
  updateDefault: ['accountId', 'paymentId'],
  deleteMethod: ['accountId', 'paymentId'],
}

export const paymentActions = generateActions(['PAYMENT'], paymentDefinition)

export default paymentActions
